import { create } from 'zustand';
import { TranscriptionModel } from '../services/voiceTranscriptionService';

interface DevConsoleState {
  transcriptionModel: TranscriptionModel;
  chatModel: string;
  simulatedRoles: string[];
  isRoleSimulationEnabled: boolean;
  setTranscriptionModel: (model: TranscriptionModel) => void;
  setChatModel: (model: string) => void;
  setSimulatedRoles: (roles: string[]) => void;
  setRoleSimulationEnabled: (enabled: boolean) => void;
}

export const useDevConsoleStore = create<DevConsoleState>((set) => ({
  transcriptionModel: 'gpt-4o-mini-transcribe',
  chatModel: 'gpt-4o-mini',
  simulatedRoles: [],
  isRoleSimulationEnabled: false,
  setTranscriptionModel: (model) => set({ transcriptionModel: model }),
  setChatModel: (model) => set({ chatModel: model }),
  setSimulatedRoles: (roles) => set({ simulatedRoles: roles }),
  setRoleSimulationEnabled: (enabled) =>
    set({ isRoleSimulationEnabled: enabled }),
}));

// Expose store to window for authenticatedFetch to access (development mode only)
if (typeof window !== 'undefined') {
  const isDevelopment =
    import.meta.env.VITE_NODE_ENV === 'development' ||
    import.meta.env.VITE_NODE_ENV === 'dev' ||
    window.location.hostname === 'localhost';

  if (isDevelopment) {
    // Create a getter that always returns current state
    Object.defineProperty(window, '__devConsoleStore', {
      get: () => ({
        getState: () => useDevConsoleStore.getState(),
      }),
      configurable: true,
    });
  }
}

